import React from 'react';

import QuestionsTable from './table/QuestionsTable';

const index = (props) => (
    <QuestionsTable />
);

export default index;
